import appActionTypes from '../constants/types'

export const initialState = {
  data: [],
  isLoading: false,
  message: null,
  errorMessage: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case appActionTypes.partner.get.requested:
    case appActionTypes.partner.create.requested:
    case appActionTypes.partner.delete.requested:
    case appActionTypes.partner.edit.requested:
      return {
        ...state,
        isLoading: true,
        message: action.message,
        errorMessage: null,
      }
    case appActionTypes.partner.get.success:
      return {
        ...state,
        data: action.data,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }

    case appActionTypes.partner.create.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      _list.push(action.data)
      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }

    case appActionTypes.partner.delete.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      var index = _list.findIndex((obj) => obj._id === action.data?._id)
      if (index !== -1) _list.splice(index, 1)

      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }

    case appActionTypes.partner.edit.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      var index = _list.findIndex((obj) => obj._id === action.data?._id)
      if (index !== -1) _list[index] = action.data

      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }
    case appActionTypes.partner.get.fail:
    case appActionTypes.partner.create.fail:
    case appActionTypes.partner.delete.fail:
    case appActionTypes.partner.edit.fail:
      return {
        ...state,
        isLoading: false,
        message: null,
        errorMessage: action.errorMessage,
      }
    default:
      return state
  }
}
